import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import UserForm from "../../components/UserForm/UserForm";
import styles from "./styles.module.css";
import "./styles.css";
import global from "../../app.module.css";
import { Link, useLocation } from "react-router-dom";
import { checkAppInfo, loginSingleSignOn, loginUser, loginWithGoogle, showModal, verifyRefreshSession } from "../../reducers/actions";
import { useLoginSelector } from "../../reducers/store";
import { selectApplication, selectLoginLoading, selectLoginSource, selectModal, selectRefreshedToken } from "../../reducers/reducer";
import Alert from '@mui/material/Alert';
import { Accordion, AccordionDetails, AccordionSummary, Button, LinearProgress, Typography } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import AppleIcon from '@mui/icons-material/Apple';
import { COMFE_ERROR_CODE, getFromStorage, logger, setToStorage } from "../../reducers/utilities";
import CancelIcon from '@mui/icons-material/CancelOutlined';
import googleSVGIcon from '../../images/logoGoogle.svg';
import logoDelegante from '../../images/logo-delegante.png';
import CustomModal from "../../components/CustomModal/CustomModal";
import Countdown from 'react-countdown';
import { encode as base64_encode } from 'base-64';

function LoginComponent(props) {
  const { urlParams } = props;
  const appId = urlParams.get('app_id');
  const sessionID = urlParams.get('sessionID');
  const tipoEmpresa = urlParams.get('tipo');
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();
  const appInformation = useLoginSelector(selectApplication);
  const loading = useLoginSelector(selectLoginLoading);
  const userSelected = useLoginSelector(selectLoginSource);
  const isModal = useLoginSelector(selectModal);
  const refreshedToken = useLoginSelector(selectRefreshedToken);
  const [personas, setPersonas] = useState(tipoEmpresa === 'E' ? 1 : 0);
  const [createuser, setCreateuser] = useState(false);

  logger(`LoginComponent.app_id ${appId}`);

  const toolTipPassword = <div id="m_pswd_info" className={styles.m_pswd_info}>
    <div>
      <span id="m_length" className="m_invalid"><CancelIcon className={styles.closeIcon} /> (Obligatorio) Longitud mínimo de 8 carácteres.</span><br />
      <span id="m_opc" className="m_invalid"> <CancelIcon className={styles.closeIcon} /> Contener al menos 3 de los siguientes 4 tipos de caracteres: </span>
      <ul>
        <li id="m_letter" className="m_invalid"> Mínimo una letra minúscula.</li>
        <li id="m_capital" className="m_invalid">Mínimo una letra mayúscula.</li>
        <li id="m_number" className="m_invalid">Mínimo un número (0-9).</li>
        <li id="m_special" className="m_invalid">Mínimo un carácter especial (!@#$%^&amp;*).</li>
      </ul>
    </div>
  </div>;

  useEffect(() => {
    if (sessionID) {
      setToStorage('sessionID', sessionID);
    }
    dispatch(showModal(true));
    dispatch(checkAppInfo(appId));
  }, []);

  useEffect(() => {
    if (!createuser && appInformation && userSelected && userSelected.uid) {
      dispatch(loginSingleSignOn({ appInformation, pathname, userSelected }));
    }
  }, [dispatch, appInformation, pathname, userSelected, createuser]);

  useEffect(() => {
    logger(`useEffect.REACT_APP_COMFENALCO_AUTHDOMAIN ${process.env.REACT_APP_COMFENALCO_AUTHDOMAIN}`);
    logger(userSelected);
    logger("showModal")
    logger(isModal);
    logger("====== ImageInformation ======");
    logger(appInformation && appInformation.urlImageImagePopup);
    logger(appInformation);

    if (userSelected &&
      userSelected.error &&
      userSelected.code === 'auth/user-not-found') {
      // goToCallBack(appInformation.urlRegister);
      setCreateuser("El usuario no se encuentra activo en los servicios de comfenalco, será redirigido a la pantalla de Registro en: ");
      setTimeout(() => {
        goToCallBack(appInformation.urlRegister);
      }, 15000);
      return;
    }

    logger(`=================== useEffect.userSelected =================`);
    logger(userSelected);
    logger(`=================== useEffect.createuser =================`);
    logger(createuser);

    if (!createuser && userSelected && userSelected.hashedUser && userSelected.uid && appInformation) {
      let target = false;
      const { email, hashedUser, providerId, accessToken, actualizarData } = userSelected;
      const storageSessionId = getFromStorage('sessionID');
      logger(`=================== useEffect.94 =================`);
      logger(actualizarData);

      if (hashedUser === COMFE_ERROR_CODE) {
        logger(`=================== useEffect.COMFE_ERROR_CODE =================`);
        target = appInformation.urlRegister;
        setCreateuser("El usuario no se encuentra activo en los servicios de comfenalco, será redirigido a la pantalla de Registro en: ");
        setTimeout(() => {
          goToCallBack(appInformation.urlRegister);
        }, 10000);
        return;
      } else if (refreshedToken) {
        logger(`=================== useEffect.refreshedToken =================`);
        let urlredirectActualizar = `${appInformation['url_callback']}?user=${email}&token=${hashedUser}&providerId=${providerId}&accessToken=${refreshedToken}${storageSessionId ? `&sessionID=${storageSessionId}` : ''}`;
        urlredirectActualizar = base64_encode(urlredirectActualizar);
        target = `${appInformation.actUsuario ? appInformation.actUsuario.url : process.env.REACT_APP_COMFENALCO_ACTUALIZAR_DATOS_URL}${appId}&sessionId=${hashedUser}&accessToken=${refreshedToken}&userType=${actualizarData.userType}&TIPOIDENTIFICACION=${actualizarData.abreviatura}&IDENTIFICACION=${actualizarData.identificacion}&urlCallback=${urlredirectActualizar}`;

        setCreateuser("El usuario se encuentra desactualizado, es necesario actualizar los datos, será redirigido a la página de actualización en: ");

        setTimeout(() => {
          goToCallBack(target);
        }, 10000);
        return;
      } else if (
        appInformation &&
        appInformation.actUsuario &&
        appInformation.actUsuario.active &&
        appInformation.isUpdateUser &&
        actualizarData && actualizarData.indActDatos === "3") {
        logger(`=================== useEffect.actUsuario =================`);
        handlerVerifySession({ accessToken, uid: userSelected.uid, token: hashedUser });
        return;
      } else if (appInformation['isAppMovil']) {
        logger(`=================== useEffect.isAppMovil =================`);
        target = `${appInformation['url_callback']}?user=${email}&token=${hashedUser}&providerId=${providerId}&accessToken=${accessToken}${storageSessionId ? `&sessionID=${storageSessionId}` : ''}`;
        window.ReactNativeWebView?.postMessage(JSON.stringify(userSelected));
      } else {
        logger(`=================== useEffect.url_callback =================`);
        target = `${appInformation['url_callback']}?user=${email}&token=${hashedUser}&providerId=${providerId}&accessToken=${accessToken}${storageSessionId ? `&sessionID=${storageSessionId}` : ''}`;
      }
      logger(`=================== useEffect.target ===================`);
      setCreateuser(false);
      logger(target);
      goToCallBack(target);
    }
  }, [userSelected, appInformation, createuser, refreshedToken, appId]);

  const handlerVerifySession = (evento) => {
    const { accessToken, uid, token } = evento;
    dispatch(verifyRefreshSession({ accessToken, uid, token }));
  };

  const goToCallBack = (target) => {
    window.location.href = target;
    return null;
  }

  const onSubmit = (evento) => {
    const { password, email } = evento;
    dispatch(loginUser({ email, password, appInformation }));
  };

  const onSubmitEmpresas = (evento) => {
    const { password, email } = evento;
    const empresas = true;
    dispatch(loginUser({ email, password, appInformation, empresas }));
  };

  const onGoogleSubmit = () => {
    dispatch(loginWithGoogle({ provider: 'google' }));
  };

  const onFacebookSubmit = () => {
    dispatch(loginWithGoogle({ provider: 'facebook' }));
  };

  const onAppleSubmit = () => {
    dispatch(loginWithGoogle({ provider: 'apple' }));
  };

  const closeModal = () => {
    logger(`closeModal`);
    dispatch(showModal(false));
  }

  return (
    <>
      {!loading && appInformation && appInformation.urlImagePopup && appInformation.urlImagePopup.length > 1 && <CustomModal urlImagen={appInformation.urlImagePopup} onCloseModal={closeModal} showModal={isModal} />}
      <div className={`${styles.contenedor} ${global.background}`}>
        <div className={styles.container} id="container">
          <div className={`${styles.loadingContainer} ${loading ? styles.show : ''}`}>
            <div className="progressContainer">
              <p>Cargando información</p>
              <LinearProgress className={styles.linearProgress} />
            </div>
          </div>
          <div className={styles.loginCentrado}>
            <div className="logo"></div>
            <img className={global.logoImage} src='/logo-comfe-cabecera-20250128.png' alt="logo" />
            {
              createuser &&
              <div className={styles.alertWarning} >
                <p>{createuser}</p>
                <Countdown className={styles.timerCountdown} date={Date.now() + 10000} />
              </div>
            }
            {
              personas === 0 &&
              <div className="personas-wrapper">
                {createuser && <div className={styles.actualizarLayout}></div>}
                <div className={styles.personalTitle} severity="success">Personas</div>
                <Typography className={styles.titleLogin}>Inicia Sesión</Typography>
                <div className={`${global.row} ${global.accordionRow}`}>
                  <Accordion className={`${global.noShadow}`}>
                    <AccordionSummary
                      className={`${styles.btn} 
                                        ${global.personalIcon} 
                                        ${global.socialButton}  
                                        ${global.accordionContent}
                                        accordionWrapper
                                        `} aria-controls="panel1a-content" id="panel1a-header">
                      <img className={global.comfeIcon} src={logoDelegante} width="24px" height="24px" alt="logo" />
                      <Typography className={styles.buttonTitle}>Cuenta Personalizada</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <UserForm onSubmit={onSubmit} submitLabel={`Iniciar Sesión`} pathname={pathname} passwordTooltip={toolTipPassword} />
                    </AccordionDetails>
                    <div className={styles.center}>
                      <Link to='/reset' className={styles.registrarLink}>¿Olvidó su contraseña?</Link>
                    </div>
                  </Accordion>
                </div>
                <Typography className={styles.titleLogin}>Inicia sesión con redes sociales</Typography>
                <div className={global.row}>
                  <Button onClick={() => onGoogleSubmit()} variant="contained" className={`${styles.btn} ${global.googleIcon} ${global.socialButton}`}>
                    <img className={global.icon} src={googleSVGIcon} alt="Google Icon button"></img>
                    Iniciar Sesión con Google
                  </Button>
                </div>
                <div className={global.row}>
                  <Button onClick={() => onFacebookSubmit()} variant="contained" className={`${styles.btn} ${global.facebookIcon} ${global.socialButton}`}>
                    <FacebookIcon className={global.icon} />
                    Iniciar Sesión con Facebook
                  </Button>
                </div>
                <div className={global.row}>
                  <Button onClick={() => onAppleSubmit()} variant="contained" className={`${styles.btn} ${global.appleIcon} ${global.socialButton}`}>
                    <AppleIcon className={global.icon} />
                    Iniciar Sesión con Apple
                  </Button>
                </div>
                <div className={global.separator}></div>
                <div className={global.row}>
                  <Typography className={styles.registrarLink}>¿Olvidó su cuenta o quiere utilizar otra?</Typography>
                  <Typography className={styles.registrarLink}>
                    Si desea ingresar por primera vez
                    {
                      appInformation ? <a className={styles.registrarLink} href={appInformation.urlRegister}>Regístrate aqui</a> :
                        <Link to='/register' className={styles.registrarLink}> Regístrate aqui</Link>
                    }
                  </Typography>
                </div>
              </div>
            }
            {
              personas === 1 &&
              <div className="empresas-wrapper">
                {createuser && <div className={styles.actualizarLayout}></div>}
                <div className={styles.personalTitle} severity="success">Empresas</div>
                <Typography className={styles.titleLogin}>Inicia Sesión</Typography>
                <div className={`${global.row} ${global.accordionRow}`}>
                  <Accordion className={`${global.noShadow}`} expanded={true}>
                    <AccordionSummary
                      className={`${styles.btn} 
                                        ${global.personalIcon} 
                                        ${global.socialButton}  
                                        ${global.accordionContent}
                                        accordionWrapper
                                        `} aria-controls="panel1a-content" id="panel1a-header">
                      <img className={global.comfeIcon} src={logoDelegante} width="24px" height="24px" alt="logo" />
                      <Typography className={styles.buttonTitle}>Cuenta Personalizada</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <UserForm onSubmit={onSubmitEmpresas} submitLabel={`Iniciar Sesión`} pathname={pathname} passwordTooltip={toolTipPassword} />
                    </AccordionDetails>
                    <div className={styles.center}>
                      <Link to='/reset' className={styles.registrarLink}>¿Olvidó su contraseña?</Link>
                    </div>
                  </Accordion>
                </div>
              </div>
            }

            <div>
              {userSelected.error
                && <Alert className={styles.alertError} severity="error">{userSelected.error}</Alert>
              }
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default LoginComponent;
